import React from 'react';
import { Box, BoxProps } from '@hawkins/components';

interface Props {
  gap?: BoxProps['gap'];
  columns?: BoxProps['gridTemplateColumns'];
}

export type GridProps = BoxProps & Props;

export const Grid = ({
  gap,
  alignContent = 'start',
  columns,
  ...props
}: GridProps) => (
  <Box
    {...props}
    gap={gap}
    display="grid"
    alignContent={alignContent}
    gridTemplateColumns={columns}
  />
);
